export default {
  GO_TRANSIT: 'GOT',
  TTC: 'TTC',
  UP_EXPRESS: 'UPE',
};
